import { render, staticRenderFns } from "./DynamicReports.vue?vue&type=template&id=4b35918b&"
import script from "./DynamicReports.vue?vue&type=script&lang=js&"
export * from "./DynamicReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports